import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const AccessView = React.lazy(() => import("./Access.view"));

const AccessLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <AccessView />
  </React.Suspense>
);

export default () => <AccessLoadable />;
